import { z } from 'zod'
import { asEnumType, asObjectType } from '@gqloom/zod'

import {
  createVersionedFileConfigFieldSchema,
  FileSupportedVariant,
  fileVersionSchema,
} from '../file-upload/file-upload.schemas'

export const DocumentSupportedVariant = {
  ...FileSupportedVariant,
} as const

export const DocumentSupportedContentType = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  txt: 'text/plain',
  rtf: 'application/rtf',
  csv: 'text/csv',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
} as const

export const DOCUMENT_SUPPORTED_VARIANTS = Object.values(
  DocumentSupportedVariant
) as (typeof DocumentSupportedVariant)[keyof typeof DocumentSupportedVariant][]

export const DOCUMENT_SUPPORTED_TYPES = Object.keys(
  DocumentSupportedContentType
) as (keyof typeof DocumentSupportedContentType)[]

const documentSupportedFormatEnumSchema = z.enum(DOCUMENT_SUPPORTED_TYPES).register(asEnumType, {
  name: 'DocumentFileVersionFormat',
})

export const documentFileVersionSchema = fileVersionSchema
  .extend({
    type: z.enum(DocumentSupportedVariant).register(asEnumType, {
      name: 'DocumentFileVersionType',
    }),
    format: documentSupportedFormatEnumSchema,
    size: z.number().optional(),
  })
  .register(asObjectType, {
    name: 'DocumentFileVersion',
  })

export const documentFileConfigFieldSchema =
  createVersionedFileConfigFieldSchema(documentFileVersionSchema)

export type DocumentFormat = keyof typeof DocumentSupportedContentType
export type DocumentFormatContentType = (typeof DocumentSupportedContentType)[DocumentFormat]
export type DocumentVariantName = (typeof DOCUMENT_SUPPORTED_VARIANTS)[number]

export type DocumentFileVersionSchema = z.infer<typeof documentFileVersionSchema>
export type DocumentFileStateColumnSchema = z.infer<typeof documentFileConfigFieldSchema>
